(() => {
  const timeZone = 'Europe/London';
  const dayFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23'
  });

  function zonedParts(date) {
    return Object.fromEntries(dayFormatter.formatToParts(date).map(({ type, value }) => [type, value]));
  }

  function calendarDate(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day));
  }

  function addDays(date, count) {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + count);
    return result;
  }

  function formatDate(date) {
    const day = date.getUTCDate();
    const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
    const month = new Intl.DateTimeFormat('en-GB', { month: 'long', timeZone: 'UTC' }).format(date);
    return `${day}${suffix} ${month}`;
  }

  function formatDispatchWhen(today, dispatchDate) {
    const weekday = dispatchDate.getUTCDay();
    const daysUntilDispatch = Math.round((dispatchDate - today) / 86400000);

    if (daysUntilDispatch === 0) return 'today';
    if (weekday === 1) return 'on Monday';
    if (daysUntilDispatch === 1) return 'tomorrow';

    const dayName = new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: 'UTC' }).format(dispatchDate);
    return `on ${dayName}`;
  }

  function nextWorkingDay(date) {
    let result = addDays(date, 1);
    while (result.getUTCDay() === 0 || result.getUTCDay() === 6) result = addDays(result, 1);
    return result;
  }

  function cutoffInstant(date) {
    const utcAtTen = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 10);
    const parts = zonedParts(new Date(utcAtTen));
    const localAtUtc = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute));
    return new Date(utcAtTen - (localAtUtc - utcAtTen));
  }

  function dispatchSchedule(now) {
    const parts = zonedParts(now);
    const today = calendarDate(Number(parts.year), Number(parts.month), Number(parts.day));
    const weekday = today.getUTCDay();
    const beforeCutoff = weekday >= 1 && weekday <= 5 && now < cutoffInstant(today);
    const dispatchDate = beforeCutoff ? today : nextWorkingDay(today);
    return { today, beforeCutoff, dispatchDate, deadline: cutoffInstant(dispatchDate) };
  }

  function renderEstimate(element, schedule) {
    const { today, beforeCutoff, dispatchDate } = schedule;
    const days = Math.max(0, Number(element.dataset.deliveryDays) || 0);

    if (element.dataset.deliveryKind === 'made-to-order') {
      if (days === 0) {
        element.textContent = element.dataset.noDateText || '';
        return;
      }
      const template = element.dataset.mtoTemplate || 'Estimated delivery __DATE__';
      element.textContent = template.replace('__DATE__', formatDate(addDays(today, days)));
      return;
    }

    const hasDeliveryEstimate = days > 0;
    const template = hasDeliveryEstimate
      ? (beforeCutoff ? element.dataset.inStockBeforeEtaTemplate : element.dataset.inStockAfterEtaTemplate)
      : (beforeCutoff ? element.dataset.inStockBeforeTemplate : element.dataset.inStockAfterTemplate);
    const estimateDate = hasDeliveryEstimate ? addDays(dispatchDate, days) : dispatchDate;
    const estimate = (template || 'Dispatches __WHEN__ (__DATE__)')
      .replaceAll('__WHEN__', formatDispatchWhen(today, dispatchDate))
      .replaceAll('__DATE__', formatDate(estimateDate));
    const cutoffNote = estimate.match(/^(.*?)(\s+if ordered before\b.*)$/i);

    if (cutoffNote) {
      const dispatchCopy = document.createElement('span');
      dispatchCopy.className = 'cart-redesign__delivery-primary';
      dispatchCopy.textContent = cutoffNote[1].trim();
      const cutoffCopy = document.createElement('span');
      cutoffCopy.className = 'cart-redesign__delivery-cutoff';
      cutoffCopy.textContent = cutoffNote[2].trim();
      element.replaceChildren(dispatchCopy, cutoffCopy);
    } else {
      element.textContent = estimate;
    }
  }

  function renderDispatchWidget(element, schedule, now) {
    const remainingMinutes = Math.max(1, Math.ceil((schedule.deadline - now) / 60000));
    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;
    const duration = [
      hours > 0 ? `${hours} ${hours === 1 ? 'hour' : 'hours'}` : '',
      minutes > 0 ? `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}` : ''
    ].filter(Boolean).join(' ');
    const outcome = element.querySelector('.cart-redesign__dispatch-outcome');

    element.querySelector('.cart-redesign__dispatch-time').textContent = duration;
    outcome.textContent = (outcome.dataset.template || "and we'll ship it __WHEN__.")
      .replaceAll('__WHEN__', formatDispatchWhen(schedule.today, schedule.dispatchDate))
      .replaceAll('__DATE__', formatDate(schedule.dispatchDate));
    element.hidden = false;
  }

  function updateEstimates() {
    const now = new Date();
    const schedule = dispatchSchedule(now);
    document.querySelectorAll('.cart-redesign__delivery-estimate').forEach(element => renderEstimate(element, schedule));
    document.querySelectorAll('.cart-redesign__dispatch-widget').forEach(element => renderDispatchWidget(element, schedule, now));
  }

  updateEstimates();
  document.addEventListener('cart-drawer:refreshed', updateEstimates);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateEstimates();
  });
  window.setInterval(updateEstimates, 15000);
})();
